import * as Schema from 'owa-graph-schema';
import getCalendarFoldersOperation from 'owa-service/lib/operation/getCalendarFoldersOperation';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import { getMailboxRequestOptions } from 'owa-request-options-types';
import { mapGetCalendarFoldersResponseToGql } from 'owa-calendars-and-groups-gql-mappers';
import { TraceErrorObject } from 'owa-trace';

/**
 * Query Web resolver responsible for calendarsAndGroups
 */
export const calendarGroupsQueryWeb = async (
    parent: any,
    args: Schema.QueryCalendarGroupsArgs,
    context: Schema.ResolverContext,
    info: any
): Promise<Schema.CalendarGroup[]> => {
    const options = getMailboxRequestOptions(args.mailboxInfo);
    const response = await getCalendarFoldersOperation({ Header: getJsonRequestHeader() }, options);

    if (response == null || !response.WasSuccessful) {
        const errorMessage = `getCalendarFoldersOperation failed with Error code: ${
            response ? response.ErrorCode : 'null response'
        }`;
        const error: TraceErrorObject = new Error(errorMessage);
        if (response) {
            error.fetchErrorType = 'ServerFailure';
        } else {
            error.networkError = true;
        }

        return Promise.reject(error);
    }

    return mapGetCalendarFoldersResponseToGql(response, args.mailboxInfo);
};
